// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".public-DraftStyleDefault-block{margin:.3em 0!important}", "",{"version":3,"sources":["webpack://./resources/src/components/CKEditor/styles.css"],"names":[],"mappings":"AACA,gCACI,uBACJ","sourcesContent":["/** Overwrite native public-DraftStyleDefault-block */\n.public-DraftStyleDefault-block {\n    margin: 0.3em 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
